import React from 'react';
import MessageList from './MessageList';
import MessageForm from './MessageForm';

// A secret message's fields (senderId/senderName) are renamed onto the field
// names MessageList already expects for a public chat message (userId/username),
// so the same list component can render both kinds of messages without needing
// to know secret chat exists.
const toDisplayMessage = (message) => ({
  ...message,
  userId: message.senderId,
  username: message.senderName,
});

// Right-column panel of the chat page: a private, one-on-one thread between the
// current user and the channel's Game Master. Nothing rendered here is ever
// visible to any other user (enforced on the backend; see chat_business.py).
const SecretChatPanel = ({ messages, currentUserId, gameMasterAgent, connected, onSend, loading }) => {
  const displayMessages = messages.map(toDisplayMessage);
  const agents = gameMasterAgent ? [gameMasterAgent] : [];

  return (
    <div className="gh-box gh-chat-secret">
      <div className="gh-box-header d-flex align-items-center gap-2">
        <i className="bi bi-shield-lock" aria-hidden="true"></i>
        <span>Secret Chat with Game Master</span>
      </div>

      {loading ? (
        <div className="gh-box-body d-flex align-items-center gap-2 text-muted-gh">
          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Loading...
        </div>
      ) : (
        <MessageList messages={displayMessages} currentUserId={currentUserId} members={[]} agents={agents} />
      )}

      <div className="gh-box-footer">
        <MessageForm
          onSend={onSend}
          disabled={!connected}
          members={[]}
          agents={agents}
          placeholder="Message the Game Master privately..."
        />
      </div>
    </div>
  );
};

export default SecretChatPanel;
